import { useMemo } from 'react';
import { useMap } from './use-map';
import { useOpen } from './use-open';

export const useCollapseItems = <T extends { id: any }>(
  selected: string[],
  items: T[],
  visible: number = 5,
  key: keyof T = 'id',
) => {
  const mapSelected = useMap(selected);
  const { isOpen, onOpen, onClose, onToggle } = useOpen();
  const [showedItems, hiddenItems] = useMemo(() => {
    return isOpen ? [items, []] : [items.slice(0, visible), items.slice(visible)];
  }, [isOpen, items, visible]);
  const countSelectedHidden = useMemo(() => {
    return hiddenItems.reduce((acc, item) => {
      // @ts-ignore
      if (mapSelected[item[key]]) {
        acc += 1;
      }
      return acc;
    }, 0);
  }, [hiddenItems, mapSelected, key]);

  return {
    isOpen,
    onOpen,
    onClose,
    onToggle,
    countSelectedHidden,
    showedItems,
    hiddenItems,
  };
};
